<template>
  <div
    :class="[
      'flex items-center justify-between',
      { 'py-3 border-t border-gray-300': !small },
      { 'mb-2': small },
    ]"
  >
    <div class="text-gray-700">{{ label }}</div>
    <div><slot></slot></div>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
    },
    small: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
